export const az = {
  'language.az': 'Azərbaycanca',
  'language.en': 'English',
  'language.hu': 'Magyar',
  'language.pt': 'Português',
  'language.ru': 'Русский',
  'language.tr': 'Türkçe',
  'language.uz': 'Oʻzbek',

  'order': 'Sifariş {order}',
  'amount': '{amount}',

  'card.sample.expiry': 'AA / YY',
  'card.sample.name': 'AD SOYAD',

  'card.pan': 'Kart nömrəsi',
  'card.owner': 'Kartdakı kimi ad və soyad',
  'card.expiry': 'AA / YY',
  'card.cvc': 'CVC',
  'card.captcha_text': 'Şəkildəki simvolları daxil edin',

  'card.btn.pay': 'Ödəniş et',

  'card.error.pan.required': 'Xananı doldurun.',
  'card.error.pan.invalid': 'Kart nömrəsi yanlışdır.',
  'card.error.pan.whitelist': 'Yalnız aşağıdakı kartlar mövcuddur: {list}.',
  'card.error.name.invalid': 'Latın hərfləri, boşluq, nöqtə və tire olmalıdır (maks. 30).',
  'card.error.name.fullname': 'Ad və soyadı daxil edin.',
  'card.error.name.required': 'Xananı doldurun.',
  'card.error.cvc.required': 'Xananı doldurun.',
  'card.error.cvc.invalid': 'Yanlış CVC.',
  'card.error.expiry.required': 'Xananı doldurun.',
  'card.error.expiry.month.invalid': 'Dəyər 01-dən 12-yə qədər olmalıdır.',
  'card.error.expiry.year.invalid': 'Cari və ya növbəti illərdən biri olmalıdır.',
  'card.error.captcha_text.required': 'Xananı doldurun.',

  'card.protected.caption.title': 'Məlumatlarınız qorunur',
  'card.protected.caption.desc': 'Bank kartı məlumatları qorunan protokollar vasitəsilə ötürülür və internet mağazasına və ya üçüncü şəxslərə təqdim edilmir. Ödənişlər PCI DSS standartına uyğun qorunan səhifədə emal olunur.',

  'card.sending.preloader.title': 'Səhifəni bağlamayın və yeniləməyin',
  'card.sending.preloader.desc': 'Keçid formalaşdırılır. Bu bir neçə saniyə və ya bir dəqiqə çəkə bilər.',

  'fatal_errors': 'İmtinanın səbəbi:',

  'card.processing.1': 'Məlumatların hazırlanması',
  'card.processing.2': 'Ödəniş imkanı yoxlanılır',
  'card.processing.3': 'Ödəniş həyata keçirilir',

  'finish.pending': 'Ödəniş emal olunur',
  'finish.pending.desc': 'Ödənişiniz qəbul edildi. Bu pəncərəni bağlayın və mağazaya qayıdın.',
  'finish.new': 'Ödəniş gözlənilir',
  'finish.new.desc': 'Ödənişiniz qəbul edildi. Bu pəncərəni bağlayın və mağazaya qayıdın.',
  'finish.complete': 'Ödəniş uğurla tamamlandı',
  'finish.complete.desc': 'Ödəniş uğurla həyata keçirildi. Bu pəncərəni bağlayın və mağazaya qayıdın.',
  'finish.failed': 'Ödəniş rədd edildi',
  'finish.failed.desc': 'Zəhmət olmasa, mağazaya qayıdın və ödənişi təkrar edin.',
  'finish.refunded': 'Ödəniş geri qaytarıldı',
  'finish.refunded.desc': ' ',
  'finish.exception': 'Nəsə səhv getdi',
  'finish.exception.desc': ' ',

  'finish.debug_info': 'Dəstəyə müraciət üçün məlumat',
  'return.btn.return': 'Mağazaya qayıt',

  'error.general': 'Nəsə səhv getdi... yenidən cəhd edin.',
}
